export default function InputSection({ children, half, column }) {
  return (
    <div
      className={`InputSection
      ${half ? "column large-6 sm-12" : "column large-12 sm-12"}
      ${column ? "flex-direction-column" : ""}
      `}
    >
      {children}
    </div>
  );
}
